import type { SVGProps } from 'react';
const SvgChevronUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 21-4.5-4.5 1.1-1.1 3.4 3.4 3.4-3.4 1.1 1.1zM8.6 8.7 7.5 7.6 12 3.1l4.5 4.5-1.1 1.1L12 5.3z"
    />
  </svg>
);
export default SvgChevronUpDown;
